import { message } from 'antd';
import cookie from 'react-cookies';
import OSS from 'ali-oss';
import CNF from './Config';
import { v4 as uuidv4 } from 'uuid';

// 导出页面为PDF格式
import html2canvas from "html2canvas";
import JSPDF from "jspdf";

/***
 * 浏览器宽度
 */
export const winWidth = getWinWidth();
function getWinWidth(){
    var winWidth  = 0;
    //  获取窗口宽度
    if (window.innerWidth){
        winWidth = window.innerWidth;
    }else if ((document.body) && (document.body.clientWidth)){
        winWidth = document.body.clientWidth;
    }
    return winWidth;
}


/***
 * 浏览器高度
 */
export const winHeight = getWinHeight();
function getWinHeight(){
    var winHeight = 0;
    //  获取窗口高度
    if (window.innerHeight){
        winHeight = window.innerHeight;
    }else if ((document.body) && (document.body.clientHeight)){
        winHeight = document.body.clientHeight;
    }
    return winHeight;
}

/***
 * 操作系统信息
 */
export const OS = getOS();
function getOS(){
    var sUserAgent = navigator.userAgent;
    var isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows');
    var isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel');
    if (isMac) return 'Mac';
    var isUnix = (navigator.platform === 'X11') && !isWin && !isMac;
    if (isUnix) return 'Unix';
    var isLinux = (String(navigator.platform).indexOf('Linux') > -1);
    if (isLinux) return 'Linux';
    if (isWin) {
        var isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
        if (isWin2K) return 'Win2000';
        var isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;
        if (isWinXP) return 'WinXP';
        var isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
        if (isWin2003) return 'Win2003';
        var isWinVista= sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
        if (isWinVista) return 'WinVista';
        var isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
        if (isWin7) return 'Win7';
        var isWin10 = sUserAgent.indexOf('Windows NT 10') > -1 || sUserAgent.indexOf('Windows 10') > -1;
        if (isWin10) return 'Win10';
    }
    return 'other';
}

export const UUID = generateUUID()
function generateUUID(){
    return uuidv4();
}

/**
 * 将图片转换成base64格式的字符串
 * @param {File|Blob} img - 表示图片的File对象或Blob对象
 * @param {Function} callback - 转换完成后的回调函数，接收一个参数，即转换后的base64字符串
 */
export function getBase64(img, callback) {
    // 创建一个FileReader对象用于读取图片数据
    const reader = new FileReader();
    
    // 当读取完成时触发load事件，调用回调函数并传入读取的结果
    reader.addEventListener('load', () => callback(reader.result));
    
    // 开始读取图片数据，将其转换为DataURL格式
    reader.readAsDataURL(img);
}

/**
 * 会员头像大小检测
 * @param {*} file 
 * @returns 
 */
export function memberAvatarCheck(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('只支持 JPG/PNG 格式的图片!');
    }
    const isLt1M = file.size / 1024  < 100;
    if (!isLt1M) {
        message.error('图像必须小于 100KB!');
    }
    return isJpgOrPng && isLt1M;
}

/**
 * 连接资源路径
 * @param {*} obj 
 * @returns 
 */
export function joinUri(obj){
    var uri = ''
    for (var i=0;i<obj.length; i++){
        uri += '/' + obj[i]
    }
    return uri
}

/**
 * 连接资源参数
 * @param {*} obj 
 * @returns 
 */
export function UjoinParams(obj){
    var params = '?'
    for (var key in obj){
        params += key + '=' + obj[key] + '&'
    }
    return params.substr(0, params.length - 1)
}

/**
 * 日期格式化
 * @param {*} fmt 
 * @param {*} date 
 * @returns 
 */
export function UdateFormat(fmt, date) {
    let ret;
    const opt = {
        'Y+': date.getFullYear().toString(),        // 年
        'm+': (date.getMonth() + 1).toString(),     // 月
        'd+': date.getDate().toString(),            // 日
        'H+': date.getHours().toString(),           // 时
        'M+': date.getMinutes().toString(),         // 分
        'S+': date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
    };
    return fmt;
}

/***
 * 获取url中'?'符后的字符串并正则匹配
 * @param {*} obj 
 * @returns 
 */
export function GetQueryString(name) {
    var reg = new RegExp('(^|[?&])' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.match(reg); //获取url中'?'符后的字符串并正则匹配
    var context = '';
    if (r != null)
        context = decodeURIComponent(r[2]);
    reg = null;
    r = null;
    return context === null || context === '' || context === 'undefined' ? '' : context;
}

/**
 * Token相关信息存入Cookie
 * @param {*} tokenArr 
 */
export function SaveCookies(tokenArr){
    cookie.save(CNF.cookies.keyId, tokenArr.info.username, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire});
    cookie.save(CNF.cookies.keyUid, tokenArr.info.uid, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire});
    cookie.save(CNF.cookies.keyDisplayname, tokenArr.info.displayname, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire});
    cookie.save(CNF.cookies.keyToken, tokenArr.access_token, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: tokenArr.expires_in});
}

/**
 * 删除cookie，并重定向到登录界面
 */
export function DeleteCookies(){
    cookie.remove(CNF.cookies.keyId, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath});
    cookie.remove(CNF.cookies.keyUid, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath});
    cookie.remove(CNF.cookies.keyDisplayname, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath});
    cookie.remove(CNF.cookies.keyToken, 
        {domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath});
    window.location.href = CNF.accountUrl;
}

/**
 * 添加请求头
 * @returns 
 */
export function AddRequestHeaders(){
    let headers = {'Accept': 'application/json'}
    headers[CNF.headerAuthKey] = cookie.load(CNF.cookies.keyToken)
    return headers
}

/***
 * elementName: 需要输出PDF的页面id
 * htmlTitle: 页面标题
 * currentTime：创建时间
 */
export function Html2pdf(elementName, htmlTitle, currentTime) {
    var element = document.getElementById(elementName)
    html2canvas(element, {
        logging: false
    }).then(function(canvas) {
        var pdf = new JSPDF("p", "mm", "a4") // A4纸，纵向
        var ctx = canvas.getContext("2d")
        var a4w = 190;
        var a4h = 257 // A4大小，210mm x 297mm，四边各保留20mm的边距
        var imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
        var renderedHeight = 0

        while (renderedHeight < canvas.height) {
            var page = document.createElement("canvas")
            page.width = canvas.width
            page.height = Math.min(imgHeight, canvas.height - renderedHeight) // 可能内容不足一页

            // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
            page.getContext("2d").putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
            pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距

            renderedHeight += imgHeight
            if (renderedHeight < canvas.height) { pdf.addPage() } // 如果后面还有内容，添加一个空页
            // delete page;
        }
        pdf.save(htmlTitle + currentTime)
    })
}

/**
 * 获取当前时间
 * YYYY-MM-dd HH:mm:ss
 * @returns 
 */
export function CurrentTime(){
    var date = new Date(); 
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var strHours = date.getHours();
    var strtMinutes = date.getMinutes();
    var strtSeconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    if (strHours >= 0 && strHours <= 9) {
        strHours = '0' + strHours;
    }
    if (strtMinutes >= 0 && strtMinutes <= 9) {
        strtMinutes = '0' + strtMinutes;
    }
    if (strtSeconds >= 0 && strtSeconds <= 9) {
        strtSeconds = '0' + strtSeconds;
    }
    var currentTime = date.getFullYear() + '-' + month + '-' + strDate + ' ' + strHours + ':' + strtMinutes + ':' + strtSeconds;
    return currentTime;
}

/**
 * 获取当前日期
 * YYYY-MM-dd
 * @returns 
 */
export function CurrentDate(){
    var date = new Date(); 
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var currentDate = date.getFullYear() + '-' + month + '-' + strDate;
    return currentDate;
}

/**
 * 获取当前月
 * YYYY-MM
 * @returns 
 */
export function CurrentMonth(){
    var date = new Date(); 
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var currentMonth = date.getFullYear() + '-' + month;
    return currentMonth;
}

/**
 * 获取上一月
 * YYYY-MM
 * @returns 
 */
export function LastMonth(){
    var date = new Date(); 
    var year = date.getFullYear();
    var month = date.getMonth();
    if (month < 1){
        month = 12;
        year -= 1;
    }
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var lastMonth = year + '-' + month;
    return lastMonth;
}

/**
 * 一月前
 * YYYY-MM-DD
 * @returns 
 */
export function MonthAgo(){
    var moment = require('moment'); // 需要安装moment.js库
    var currentDate = moment();     // 获取当前日期
    var monthAgo = currentDate.subtract(30, 'days').format('YYYY-MM-DD');
    return monthAgo;
}

/**
 * 将指定的文本值复制到剪贴板。
 * @param {string} value 需要被复制的文本。
 * 
 * 函数首先判断当前浏览器是否支持navigator.clipboard.writeText方法来直接复制文本到剪贴板。
 * 如果支持且当前环境是安全上下文（https协议或localhost），则使用现代的剪贴板API进行复制。
 * 如果不支持或环境不安全，则回退到传统的方法：创建一个textarea元素，将文本填入，选中文本后使用document.execCommand('copy')进行复制。
 * 不论采用哪种方式，复制成功或失败后都会给出相应的用户反馈。
 */
export function CopyToClipboard(value){
    // 兼容性判断，选择合适的复制方法
    if(navigator.clipboard && window.isSecureContext){
        // 使用现代浏览器的剪贴板API
        navigator.clipboard.writeText(value).then(()=>{
            // 复制成功后的处理
            message.success('复制成功');
        }).catch((error)=>{
            // 复制失败后的处理
            message.error('复制失败');
        })
    }else{
        // 对于不支持现代剪贴板API的浏览器的处理
        const input = document.createElement('textarea');
        input.value = value;
        document.body.appendChild(input);
        input.select(); 
        document.execCommand('copy'); 
        document.body.removeChild(input);
        // 成功复制的处理，这里和现代API分支共享相同的反馈逻辑
        message.success('复制成功');
    }
}

/**
 * 根据标签ID，将滚动条移到最下面
 * @param {*} id 
 */
export function ToScrollBottom(id){
    let d = document.getElementById(id);
    d.scrollTop = d.scrollHeight;
}

/**
 * 连接阿里云OSS实体
 * @param {*} token
 * @returns 
 */
export const AliyunOSSclient = (token) => { 
    return new OSS({
        region: token.oss_region,
        accessKeyId: token.Credentials.AccessKeyId,
        accessKeySecret: token.Credentials.AccessKeySecret,
        stsToken: token.Credentials.SecurityToken,
        secure: true,
        bucket: token.bucket_name
    });
}

//  经纬度转换
//  定义一些常量
/* eslint-disable */
var PI = 3.1415926535897932384626
var a = 6378245.0
var ee = 0.00669342162296594323

/**
 * 判断是否在国内，不在国内则不做偏移
 * @param lng
 * @param lat
 * @returns {boolean}
 */
function OutOfChina(lng, lat) {
    lat = +lat
    lng = +lng
    // 纬度3.86~53.55,经度73.66~135.05
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)
}
/**
 * 转换经度
 * @param {*} lng 
 * @param {*} lat 
 * @returns 
 */
function TransformLNG(lng, lat) {
    var lat = +lat;
    var lng = +lng;
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
    return ret;
}
/**
 * 转换纬度
 * @param {*} lng 
 * @param {*} lat 
 * @returns 
 */
function TransformLAT(lng, lat) {
    var lat = +lat;
    var lng = +lng;
    var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
    return ret;
}

/**
 * WGS84转GCJ02
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function WGS84ToGCJ02(lng, lat) {
    var lat = +lat;
    var lng = +lng;
    if (OutOfChina(lng, lat)) {
      return [lng, lat];
    } else {
        var dlng = TransformLNG(lng - 105.0, lat - 35.0);
        var dlat = TransformLAT(lng - 105.0, lat - 35.0);
        var radlat = lat / 180.0 * PI;
        var magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        var sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        var mglat = lat + dlat;
        var mglng = lng + dlng;
        return [mglng, mglat];
    }
}

/**
 * GCJ02转WGS84
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function GCJ02toWGS84(lng, lat) {
    var lat = +lat;
    var lng = +lng;
    if (OutOfChina(lng, lat)) {
        return [lng, lat];
    } else {
        var dlng = TransformLNG(lng - 105.0, lat - 35.0);
        var dlat = TransformLAT(lng - 105.0, lat - 35.0);
        var radlat = lat / 180.0 * PI;
        var magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        var sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        var mglat = lat + dlat;
        var mglng = lng + dlng;
        return [lng * 2 - mglng, lat * 2 - mglat];
    }
}